import { EAlertActionTypes } from '../../actions/alert';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function alertReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EAlertActionTypes.Show:
      return {
        ...state,
        alert: {
          isVisible: true,
          type: action.payload?.type,
          message: action.payload?.message,
          chatId: action.payload?.chatId,
        },
      };

    case EAlertActionTypes.Hide:
      return {
        ...state,
        alert: {
          isVisible: false,
        },
      };

    default:
      return state;
  }
}
